import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import {
  StyledButton,
  StyledInput,
} from "../styledComponents/CommonStyledComponents";
import { StyledRegisterFormGroup } from "../styledComponents/StyledSignupLogin";

export const LeaderboardDialog = ({ showModal, handleProceed, skin }) => {
  const { t } = useTranslation("");
  const [leaderboardValue, setLeaderboardValue] = useState(null);

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody>{t("please_insert_leaderboard")}</StyledModalBody>
      <StyledModalBody>
        <StyledRegisterFormGroup step>
          <StyledInput
            inputLg
            type="text"
            value={leaderboardValue}
            name="leaderboard"
            maxLength="30"
            onChange={(e) => setLeaderboardValue(e.target.value)}
          />
        </StyledRegisterFormGroup>
      </StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed(leaderboardValue)}
          disabled={leaderboardValue === null || leaderboardValue.length < 3}
        >
          {t("label_ok", "Ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
